import React from 'react'
import { useIntl } from 'react-intl'

import WarningIcon from 'client/icons/Warning'

import styles from './styles.module.css'
import { bankErrorCodes } from './constants'
import { ERROR_CODES } from 'client/pages/constants'

type Props = {
  subCode: number
}

type ErrorMessagesType = {
  errorMessageTitle: { id: string }
  errorMessage: { id: string } | null
}

export function getErrorMessages(subCode: number) {
  if (subCode === ERROR_CODES.INVALID_CARD) {
    return {
      errorMessageTitle: { id: 'payment.try-again-cta' },
      errorMessage: { id: 'payment.try-again-message' },
    }
  }

  const isBankError = bankErrorCodes.includes(subCode)

  return {
    errorMessageTitle: isBankError
      ? { id: 'payment.try-contacting-bank' }
      : { id: 'error.default' },
    errorMessage: !isBankError ? { id: 'payment.try_again_other_card' } : null,
  }
}

const PaymentErrorMessage = ({ subCode }: Props) => {
  const { formatMessage } = useIntl()
  const { errorMessageTitle, errorMessage }: ErrorMessagesType = getErrorMessages(subCode)

  return (
    <div role="alert" className={styles.errorMessageContainer}>
      <div className={styles.errorMessage}>
        <div className={styles.errorMessageTitle}>
          <WarningIcon />
          {formatMessage(errorMessageTitle)}
        </div>
        {errorMessage && formatMessage(errorMessage)}
        {process.env.NEXT_PUBLIC_MASTERCARD_ERROR_MSG
          ? formatMessage({ id: 'payment.mastercard-issue' })
          : null}
      </div>
    </div>
  )
}

export default PaymentErrorMessage
